export default __webpack_public_path__ + "static/uneven-2ad2c84e9506f1f8802cd2e6a1c8bf34.png";